import router from './routes'
import './directives'
import LoadingText from './components/Support/LoadingText.vue'
import App from './app.vue'
import store from './store'

window.store = store;
Vue.component('loading-text', LoadingText);

new Vue({
    el: '#root',

    components: {
        'app': App,
    },

    router,
    store,

    methods: {
        registerSearchListener() {
            debug.log('Registering search listener.');
            Event.listen('search-updated', () => {
                if (this.$route.name !== 'records_table') {
                    debug.log('Event received: navigating to records table');
                    this.$store.commit('setSearchCache', null);
                    this.$router.push({name: 'records_table'});
                }
            });
        }
    },

    mounted() {
        this.registerSearchListener();

        // The search listener is removed at some point, so we must be able to re-register it
        Event.listen('register-search-listener', () => this.registerSearchListener());
    }
});
